
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvBookingLegacySections.html?raw';
import '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import '../../../moreCore/UI/CheckBox/CheckBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import '../../../moreCore/UI/SelectEntityDialog/SelectEntityDialog';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import _StatefulBase from '../../../moreCore/UI/_StatefulBase/_StatefulBase';
import "../../../moreCore/UI/_StatefulBase/_StatefulBase";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import EvProgramEditor from '../../EvBookingEditor/EvProgramEditor/EvProgramEditor';
import '../../EvBookingEditor/EvProgramEditor/EvProgramEditor';
import VoiceAttributeEditForm from '../../VoiceAttributeEditForm/VoiceAttributeEditForm';

//import EvCastEditor = require("../EvCastEditor/EvCastEditor");
//import "../EvCastEditor/EvCastEditor";

//import ServiceEditor = require("../ServiceEditor/ServiceEditor");
//import "../ServiceEditor/ServiceEditor";

//import EvCategoriesEditor = require("../EvCategoriesEditor/EvCategoriesEditor");
//import "../EvCategoriesEditor/EvCategoriesEditor";

//import EvTaskEditor = require("../EvTaskEditor/EvTaskEditor");
//import "../EvTaskEditor/EvTaskEditor";

//import FilesEditor = require("../FilesEditor/FilesEditor");
//import "../FilesEditor/FilesEditor";

import {
    ProjectWizard,
    EvCastEditor,
    ServiceEditor,
    EvCategoriesEditor,
    EvTaskEditor,
    FilesEditor,
    VAMtypes,
    VAMclassNames,
    EvBookingEditor
} from "../../../WidgetCollection/_loadingHelpers/VAM";

import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';

/*
import EvProgramEditor = require('../EvProgramEditor/EvProgramEditor');
import '../EvProgramEditor/EvProgramEditor';

import EvCastEditor = require("../EvCastEditor/EvCastEditor");
import "../EvCastEditor/EvCastEditor";
*/

import on from 'dojo/on';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';

import FileUpload from '../../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import "../../../moreCore/UI/Filetransfer/FileUpload/FileUpload";
import domStyle from 'dojo/dom-style';
import FileUploadDisplay_ListRow from '../../../moreCore/UI/Filetransfer/FileUpload/FileUploadDisplay_ListRow/FileUploadDisplay_ListRow';
import ExpandableSection from '../../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings, HTMLElementWithExpander } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import Tooltip from '../../../moreCore/UI/Floating/Tooltip';
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import EvServiceEditor from '../EvService/EvServiceEditor/EvServiceEditor';


interface EvBookingEditor_TableConfig {
    name: EvBookingEditor_ListNames,
    staticTable: MdsLax<InstanceType<typeof StaticTable>>,
    tableContainer: HTMLElement,
    sectionContainer: HTMLElementWithExpander,
    tableLayout: StaticTable.RowConfig,
    isVisible: boolean
}
class EvBookingLegacySections extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private evBookingEditorSectionsConfig: EvBookingEditor_SectionsConfig = null;

    private bookerInput: MdsLax<InstanceType<typeof SearchSelect>>;
    private bookerInputSection_container: HTMLElement;
    private bookerInput_container: HTMLElement;

    private evCategoriesEditor: MdsLax<InstanceType<typeof EvCategoriesEditor>>;
    private castEditor: MdsLax<InstanceType<typeof EvCastEditor>>;
    private programEditor: MdsLax<InstanceType<typeof EvProgramEditor>>;

    //bookingCast: StaticTable;
    //bookingProgram: StaticTable;
    //bookingServices: StaticTable;
    //evTasksTable: StaticTable;
    //evCategoriesTable: StaticTable;
    //bookingOrchesterEmployment: StaticTable;
    //existingFilesTable: StaticTable;
    //programDlg: GenericDialog;
    //castProgram: StaticTable;
    //castDlg: GenericDialog;

    private oversteeredPriceCheckbox: MdsLax<InstanceType<typeof CheckBox>>;
    private freePriceCheckbox: MdsLax<InstanceType<typeof CheckBox>>;
    private priceTotalPricelistCheckbox: MdsLax<InstanceType<typeof CheckBox>>;

    private txtServiceEditorHeading: HTMLElement;
    private numberInput_PriceUnitChange: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_PriceUnitPricelist: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_PriceTotalPricelist: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_ValueAgiodisagioUnit: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_ValueAgiodisagioTotal: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_Discount: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_ValueDiscountUnit: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_ValueDiscountTotal: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_PriceUnitAfterDisc: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_PriceTotalAfterDisc: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_VatValue: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_PriceTotalInclVat: MdsLax<InstanceType<typeof NumberInput>>;

    private edit_serviceTxt: MdsLax<InstanceType<typeof Edit>>;
    private edit_serviceNoteInternalTxt: MdsLax<InstanceType<typeof Edit>>;

    private inputSelectedAssociate: MdsLax<InstanceType<typeof SearchSelect>>;
    private originalSelectedAssociateValue: string = "";
    private selectedAssociateData: any = {};

    private saveChangesButton: HTMLButtonElement;
    private saveAssociate: HTMLButtonElement;

    private bookingCastTableContainer: HTMLElement;
    private bookingProgramTableContainer: HTMLElement;
    private serviceTableContainer: HTMLElement;
    private servicesEditorContainer: HTMLElement;
    private servicesEditorMessageContainer: HTMLElement;
    private servicesEditor_PriceEditorContainer: HTMLElement;
    private servicesEditor_TextEditorContainer: HTMLElement;
    private servicesEditor_NoteInternalTextEditorContainer: HTMLElement;
    private evTaskMessageContainer: HTMLElement;
    private orchesterEmploymentTableContainer: HTMLElement;
    private castContainer: HTMLElementWithExpander;
    private programContainer: HTMLElementWithExpander;
    private serviceContainer: HTMLElementWithExpander;
    private evTaskContainer: HTMLElementWithExpander;
    private evTaskAssociateEditorContainer: HTMLElement;
    private evCategoryContainer: HTMLElementWithExpander;
    private orchesterEmploymentContainer: HTMLElementWithExpander;
    private filesSectionContainer: HTMLElementWithExpander;
    private bookingEvTaskTableContainer: HTMLElement;
    private bookingEvCategoryTableContainer: HTMLElement;

    private bookingDateStart: Date = null;
    private bookingDateEnd: Date = null;

    private editedServiceBooking: VAMtypes.EvServiceBooking = null;

    private evTaskEditor_container: HTMLElement;
    private evTaskEditor: MdsLax<InstanceType<typeof EvTaskEditor>>;

    private fileUpload: MdsLax<InstanceType<typeof FileUpload>>;
    private fileCategories: Array<{ ID: string, description: string }> = [];
    private bookingFilesTableContainer: HTMLElement;
    private newUploadFiles: any[] = [];

    tablesConfig: {
        cast: EvBookingEditor_TableConfig,
        program: EvBookingEditor_TableConfig,
        service: EvBookingEditor_TableConfig,
        evTasks: EvBookingEditor_TableConfig,
        evCategories: EvBookingEditor_TableConfig
        orchestraEmployments: EvBookingEditor_TableConfig,
        existingFiles: EvBookingEditor_TableConfig,
    } = null;
    private markedRow: any = null;
    private serviceEditor: MdsLax<InstanceType<typeof ServiceEditor>>;
    private overlappingBookingsMessageContainer: HTMLDivElement;
    private overlappingBookingsViewContainer: HTMLDivElement;

    castTableLayout: StaticTable.RowConfig = {
        colNamesInternal: ["c_cast_address", "c_cast_perfomer", "castAktionen"],
        "attributes": ["c_cast_address", "c_cast_perfomer"],
        "colspans": [1, 1, 1],
        "headings": [(this as any).translations["BookingEditor__castAddressTableHeader"], (this as any).translations["BookingEditor__castRoleTableHeader"], "castAktionen"],
        widths: [null, null, "15ch"],
        alignmentsHeading: [null, null, "right"],
        alignmentsRow: [null, null, "right"]
    }
    programTableLayout: StaticTable.RowConfig = {
        "attributes": ["c_composer_author", "c_opus", "duration_min"],
        colNamesInternal: ["c_composer_author", "c_opus", "duration_min", "prgAktionen"],
        "colspans": [1, 1, 1, 1],
        "headings": [(this as any).translations["BookingEditor__programAuthorHeader"], (this as any).translations["BookingEditor__programTitleHeader"], (this as any).translations["BookingEditor__programDurationHeader"], "prgAktionen"],
        widths: [null, null, "10ch", "15ch"],
        alignmentsHeading: [null, null, null, "right"],
        alignmentsRow: [null, null, null, "right"]

    }
    programTableLayout_om: StaticTable.RowConfig = {
        "attributes": ["c_composer_author", "c_opus", "TXT_EvProgram_Display_cast", "duration_min"],
        colNamesInternal: ["c_composer_author", "c_opus", "TXT_EvProgram_Display_cast", "duration_min", "prgAktionen"],
        "colspans": [1, 1, 1, 1, 1],
        "headings": [(this as any).translations["BookingEditor__programAuthorHeader"], (this as any).translations["BookingEditor__programTitleHeader"], (this as any).translations["BookingEditor__programInstrumentation"], (this as any).translations["BookingEditor__programDurationHeader"], "prgAktionen"],
        widths: [null, null, null, "10ch", "15ch"],
        alignmentsHeading: [null, null, null, null, "right"],
        alignmentsRow: [null, null, null, null, "right"]

    }
    serviceTableLayout: StaticTable.RowConfig = {
        "attributes": ["description", "service_type_text", "quantity_text", "price_total_pricelist", ""],
        colNamesInternal: ["description", "service_type_text", "quantity_text", "price_total_pricelist", "ServiceAktionen_WithEdit"],
        "colspans": [1, 1, 1, 1],
        "headings": ["General_Description", "General_Label_Type", "General_Label_Quantity", "General_Label_Price", "ServiceAktionen_WithEdit"],
        widths: [null, "16ch", "25ch", "10ch", "16ch"],
        alignmentsHeading: [null, null, null, null, "right"],
        alignmentsRow: [null, null, null, null, "right"]
    };

    evTaskTableLayout: StaticTable.RowConfig = {
        "attributes": ["ref_task_description.description", "ref_vt_address_backoffice.gDisp_1"],
        colNamesInternal: ["ref_task_description.description", "ref_vt_address_backoffice.gDisp_1", "Aktionen_EditDelete"],
        "colspans": [1, 1, 1],
        "headings": ["Diensttyp", "Mitarbeiter", "Aktionen_EditDelete"],
        widths: [null, null, "10ch"],
        alignmentsHeading: [null, null, "right"],
        alignmentsRow: [null, null, "right"]
    };

    evCategoriesTableLayout: StaticTable.RowConfig = {
        "attributes": ["code", "description"],
        colNamesInternal: ["code", "description", "Aktionen_DeleteOnly"],
        "colspans": [1, 1, 1],
        "headings": [(this as any).translations["General_Label_Code"], (this as any).translations["General_Description"], "Aktionen_DeleteOnly"],
        widths: ["10ch", null, "10ch"],
        alignmentsHeading: [null, null, "right"],
        alignmentsRow: [null, null, "right"]

    }

    orchesterEmploymentTableLayout: StaticTable.RowConfig = {
        "attributes": ["ref_associate.gDisp_Name_Firstname", "ref_functional_group.description", "ref_vt_duty_type.code"],
        colNamesInternal: ["ref_associate.gDisp_Name_Firstname", "ref_functional_group.description", "ref_vt_duty_type.code"],
        "colspans": [1, 1, 1],
        "headings": [(this as any).translations["EmploymentFinder__musician"], (this as any).translations["EmploymentFinder__functionalGroup"], (this as any).translations["EmploymentFinder__employmentType"]]
    }

    existingFilesTableLayout: StaticTable.RowConfig = {
        "attributes": ["filename", "keyword", "ref_file_category.description", "ref_entity_1.$ClassPrintname"],
        colNamesInternal: ["filename", "keyword", "ref_file_category.description", "Source", "Aktionen_DownloadDelete"],
        "colspans": [1, 1, 1, 1, 1],
        "headings": [(this as any).translations["General_Label_Filename"], (this as any).translations["General_Label_Keyword"], (this as any).translations["General_Label_Category"], (this as any).translations["General_Label_Source"], "Aktionen_DownloadDelete"],
        widths: [null, null, null, null, "10ch"],
        alignmentsHeading: [null, null, null, null, "right"],
        alignmentsRow: [null, null, null, null, "right"]
    }

    table_formatterFunction__headingLabel: Function = lang.hitch(this, function (headingLabel: string) {
        switch (headingLabel) {
            case "Aktionen_DeleteOnly":
            case "Aktionen_DownloadDelete":
            case "Aktionen_WithEdit":
            case "ServiceAktionen_WithEdit":
            case "Aktionen_EditDelete":
            case "castAktionen":
            case "srvAktionen":
            case "prgAktionen":
                return (this as any).translations["General_Label_Actions"];
        }

        return headingLabel;
    });

    table_formatterFunction(cell: StaticTable.StaticTableCell<object>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        //console.log("rowIndex", rowIndex);
        //console.log("NODE", node, "ENTITY", entity, "colName", colName, "VALUE", value, "ROW INDEX", rowIndex, "CELL", cell);
        if ((entity["Classname"] == "service_ev_serv" || entity["Classname"] == "pos_ev_serv") && entity["service_type"] === 1) {

            domStyle.set(cell.tableCellNode, "vertical-align", "middle");
        }

        let isRed = (entity["Classname"] == "ev_program" || entity["Classname"] == "opus") &&
            (entity["is_red_entry"] || (entity["Classname"] == "ev_program" && entity["ref_opus"] == null));

        isRed = isRed || (entity["Classname"] == VAMclassNames.ev_cast || entity["Classname"] == VAMclassNames.performers) &&
            (entity["is_red_entry"] || (entity["Classname"] == VAMclassNames.ev_cast && entity["ref_performer"] == null));

        if (isRed && colName.indexOf("Aktionen") == -1) this.UiModder.domClass.add(node, "w3-text-red");

        //cell.formattingHandled = true;
        let icon = null;
        switch (colName) {
            case this.translations["BookingEditor__programDurationHeader"]:
            case "duration_min":
                if (value) {
                    node.innerHTML = value + " min";
                    return true;
                }
                break;

            case "Aktionen_WithEdit":

                icon = this.createFontawesomeIcon("fas fa-edit hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "edit", cell.tableRow));

                if ((entity["Classname"] == "service_ev_serv" || entity["Classname"] == "pos_ev_serv") && (entity["service_type"] != 1 && entity["service_type"] != 4)) {
                    this.UiModder.domClass.add(icon, "w3-disabled");
                }

                icon = this.createFontawesomeIcon("fas fa-chevron-circle-up hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "moveup", cell.tableRow));
                icon = this.createFontawesomeIcon("fas fa-chevron-circle-down hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "movedown", cell.tableRow));

                icon = this.createFontawesomeIcon("fas fa-trash hoverTxtPrimary secondaryText warningTXT", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "delete", cell.tableRow));

                return true;
                break;
            case "ServiceAktionen_WithEdit":

                let svb = entity as VAM2types.EvServiceBooking;

                icon = this.createFontawesomeIcon("fas fa-edit hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "edit", cell.tableRow));

                if ((entity["Classname"] == "service_ev_serv" || entity["Classname"] == "pos_ev_serv") && (entity["service_type"] != 1 && entity["service_type"] != 4)) {
                    this.UiModder.domClass.add(icon, "w3-disabled");
                }

                icon = this.createFontawesomeIcon("fas fa-chevron-circle-up hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "moveup", cell.tableRow));
                icon = this.createFontawesomeIcon("fas fa-chevron-circle-down hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "movedown", cell.tableRow));



                if (svb.is_cancelled) {
                    this.disableNode(cell.tableRow.node);
                    this.UiModder.domClass.add(cell.tableRow.node, "cancelled w3-opacity strike");
                }
                else if (typeof (svb.documents) == "undefined" || svb.documents.length == 0) {
                    icon = this.createFontawesomeIcon("fas fa-trash hoverTxtPrimary secondaryText warningTXT", "", node);
                    on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "delete", cell.tableRow));
                } else if (svb.is_cancelled != true) {
                    icon = this.createFontawesomeIcon("fas fa-ban hoverTxtPrimary secondaryText", "", node);
                    //on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "delete", cell.tableRow));
                    on(icon, "click", lang.hitch(this, this._onClick_CancelServiceBooking, cell));

                }

                return true;
                break;
            case "Aktionen_EditDelete":
                icon = this.createFontawesomeIcon("fas fa-edit hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "edit", cell.tableRow));

                icon = this.createFontawesomeIcon("fas fa-trash hoverTxtPrimary secondaryText warningTXT", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "delete", cell.tableRow));

                return true;
                break;
            case "Aktionen_DeleteOnly":
                icon = this.createFontawesomeIcon("fas fa-trash hoverTxtPrimary secondaryText warningTXT", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "delete", cell.tableRow));
                return true;
                break;
            case "Aktionen_DownloadDelete":
                icon = this.createFontawesomeIcon("fas fa-download hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "download", cell.tableRow));

                let disabled = "";
                //if (!entity["ref_entity_1"] /*|| entity["ref_entity_1"]["ID"] !== this.currentData.ID*/) disabled = "w3-disabled";
                icon = this.createFontawesomeIcon(`fas fa-trash hoverTxtPrimary secondaryText warningTXT ${disabled}`, "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "delete", cell.tableRow));

                return true;
                break;

            case "Source":
                let sourceTooltip = new Tooltip();
                let fileEntity = entity as any;
                if (fileEntity?.ref_entity_1) {
                    sourceTooltip.setup({
                        content: fileEntity.ref_entity_1["$Displayname"],
                        targetnode: node,
                        enableHover: true,
                        heading: value
                    });
                    node.innerHTML = this.createFontawesomeIcon("fas fa-info-circle", "&nbsp;").outerHTML + value;
                    return true;
                }
                break;
            case "TXT_EvProgram_Display_cast":

                if (entity["is_red_entry"] || (entity as VAM2types.EvProgram).ref_opus == null) {
                    node.innerHTML = "";
                } else {
                    let instrumentationTooltip = new Tooltip();
                    instrumentationTooltip.setup({
                        content: value,
                        targetnode: node,
                        enableHover: true,
                        heading: ""
                    });

                    let instrumentationEditIcon = this.createFontawesomeIcon("fas fa-edit hoverTxtPrimary secondaryText w3-margin-right", "&nbsp;", node);
                    on(instrumentationEditIcon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "editInstrumentation", cell.tableRow));

                    node.append(value);
                }

                return true;
                break;
            case "Aktionen":
            case "castAktionen":
            case "prgAktionen":
                icon = this.createFontawesomeIcon("fas fa-chevron-circle-up hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "moveup", cell.tableRow));
                icon = this.createFontawesomeIcon("fas fa-chevron-circle-down hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "movedown", cell.tableRow));

                icon = this.createFontawesomeIcon("fas fa-trash hoverTxtPrimary secondaryText warningTXT", "", node);
                on(icon, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, "delete", cell.tableRow));
                return true;
                break;
            case "quantity_text":

                if (entity["service_type"] === 1) {

                    let numberInput = new NumberInput();
                    numberInput.setValue(entity["quantity_multiplier"], true);
                    numberInput.setMaxRange(999);
                    numberInput.setMinRange(1);
                    numberInput.placeAt(node);
                    numberInput.setUnit(value);

                    on(numberInput, "change", lang.hitch(this, this._onChange_ServiceQuantity, entity));
                } else {

                    node.innerHTML = value;
                }
                return true;
                break;

            case "is_cancelled":


                let cb = new CheckBox();
                cb.setValue(entity["is_cancelled"], true);
                cb.placeAt(node);


                if (entity["Classname"] == "pos_ev_serv" && typeof (entity["documents"]) != "undefined" && entity["documents"].length > 0) {
                    cb.setReadonly(false);
                } else {
                    cb.setReadonly(true);
                }

                on(cb, "change", lang.hitch(this, this._onChange_ServiceCancelCheckbox, rowIndex, entity));

                return true;
                break;
            case "price_total_pricelist":

                if (entity["service_type"] === 1) {

                    if (entity["state"] === "new") {

                        node.innerHTML = "<i>" + this.translations["EvBookingditor_ToCalculate"] + "</i>";
                    }
                    else {

                        node.innerHTML = parseFloat(value).toFixed(2) + " €";
                    }
                } else {

                    node.innerHTML = "";
                }
                return true;
                break;

            case "description":

                if (entity["Classname"] == "service_ev_serv" || entity["Classname"] == "pos_ev_serv") {

                    on(node, "click", lang.hitch(this, this._onClick_TableRowAction, entity, rowIndex, false, cell.tableRow));

                    if (entity["service_type"] == 4) {

                        if (entity["description"] === entity["service_original_description"]) {

                            node.innerHTML = value;
                        } else {

                            let tooltip = new Tooltip();

                            tooltip.setup({
                                content: `${this.translations["EvBookingditor_textService_inputLabel"]}: ${value}`,
                                targetnode: node,
                                delayMS: 250,
                                enableHover: true,
                                heading: entity["service_original_description"]
                            });
                            node.innerHTML = this.createFontawesomeIcon("fas fa-asterisk", "&nbsp;").outerHTML + value;
                        }
                        return true;
                    }
                }

                node.innerHTML = value;
                return true;
                break;

            case "Mitarbeiter":
                value ? node.innerHTML = value : node.innerHTML = "N.A.";
                return true;
                break;

            case "ev_service_text_internal":
                if (!value) return false;

                let tooltip = new Tooltip();

                tooltip.setup({
                    content: value,
                    targetnode: node,
                    delayMS: 250,
                    enableHover: true,
                    heading: null
                });
                node.innerHTML = /*this.createFontawesomeIcon("fas fa-info-circle", "&nbsp;").outerHTML + */value;
                return true;
                break;

            case "discount":
                if (entity["service_type"] === 1 && typeof (value) == "number") {
                    node.innerHTML = `${value} %`;
                } else {
                    node.innerHTML = "";
                }

                return true;
                break;
            default:
                return false;
        }
    }

    // values set from parent widget, if such exists
    isValidationEnabled: boolean = true;
    _isFormInDialog: boolean = false;
    bookingStatusPresetValue: string | {} = null;
    activityStatusPresetValue: string | {} = null;
    audienceSeatingLayoutPresetValue: string | {} = null;
    evProjectPresetValue: string | {} = null;
    bookerInputPresetValue: string | {} = null;



    // --------------------------inputEvents -----------------------START
    private _onChange_ServiceQuantity(entity: any, value): void {

        entity["quantity_multiplier"] = value;
        this.checkIsFormDirty();

        if (this.editedServiceBooking != null) {

            this.editedServiceBooking = null
            this.hideNode(this.servicesEditorMessageContainer, false);
            this.hideNode(this.servicesEditorContainer);
        }
    }

    private _onChange_ServiceCancelCheckbox(rowIndex, entity: any, value: boolean): void {

    //    this.currentData[EvBookingEditor_ListNames.EvService][rowIndex].is_cancelled = true;// value;

    //    this.checkIsFormDirty();
    }


    private _onClick_CancelServiceBooking(cell: StaticTable.StaticTableCell<VAM2types.EvServiceBooking>): void {

        let entity = cell.entity;
        entity.is_cancelled = !entity.is_cancelled;

        this.UiModder.domClass.toggle(cell.tableRow.node, "cancelled  w3-opacity strike", entity.is_cancelled);

        this.checkIsFormDirty();
    }

    //private _onChange_ServicePrice(entity: any, value): void {

    //    entity["price_total_pricelist"] = value;
    //}

    setRoomItem(roomItem: object) {
        let data = this.currentData as VAM2types.AudienceSeatingLayout;

        this.setAttributeValue("ref_ev_room", roomItem);
    }

    private _onClick_TableRowAction(
        entity: any,
        rowIndex: number,
        actionType: "delete" | "edit" | "moveup" | "movedown" | "download" | "editInstrumentation" | "cancel",
        row: any = null,
        evt: any
    ): void {
        console.log("TableRowClick", evt.target);
        let entityClass: VAMclassNames = entity["Classname"];
        let entityID = entity["ID"];
        if (!entityID) entityID = entity["GUID"]; // kann temporär bei neuen Entities sein
        let entityState: "new" | "deleted" = entity["state"];

        // Pricelist table
        //if (isPriceClick && (entity["Classname"] == "service_ev_serv" || entity["Classname"] == "pos_ev_serv") && entity["service_type"] == 1) {

        if (actionType == "editInstrumentation") {
            console.log(entityClass, entityID, "editInstrumentation");

            let form = new VoiceAttributeEditForm();
            form.setData(entity);

            let dlg = new GenericDialog();
            dlg.callback = lang.hitch(this, function (form: MdsLax<InstanceType<typeof VoiceAttributeEditForm>>, rowIndex: number, result) {
                let changedData = form.getChangedData();


                let currentEntity = this.currentData[EvBookingEditor_ListNames.EvProgram][rowIndex];
                this.currentData[EvBookingEditor_ListNames.EvProgram][rowIndex] = lang.mixin(currentEntity, changedData);
                this.checkIsFormDirty();

            }, form, rowIndex);
            dlg.show(form, this.getTranslation("BookingEditor__programEditInstrumentation") + " ( " + entity.c_opus + " )",null, null, "ok");


            return;
        }

        if (actionType == "edit") {

            if ((entityClass == VAMclassNames.service_ev_serv ||
                entityClass == VAMclassNames.pos_ev_serv) && (entity["service_type"] == 1 || entity["service_type"] == 4)) {

                if (!this.checkIsFormDirty()) {

                    if (this.markedRow) {

                        this.UiModder.domClass.remove(this.markedRow, "EvBookingEditorForm selectedTableRow");

                        if (this.markedRow == row.node) {
                            this._onClick_CloseServiceEditorContainer(null);
                            //return;
                       }
                    }

                    this.markedRow = row.node;
                    this.UiModder.domClass.add(this.markedRow, "EvBookingEditorForm selectedTableRow");

                    let editorDlg = new EvServiceEditor();
                    editorDlg.openEditor(entity);
                    editorDlg.on("saveChanges_success", lang.hitch(this, () => { this.emit("bookingEditorPricelistCalculationResponse") }))
                    //this.openServiceEditor(entity);

                } else {
                    this.hideNode(this.servicesEditorMessageContainer, false);
                }
            }

            else if (entityClass == VAMclassNames.ev_task_single || entityClass == VAMclassNames.ev_task_descript
                || entityClass == VAMclassNames.ev_task_type_A0) {
                if (!this.checkIsFormDirty()) {
                    let singleTask = entity as VAM2types.EvTaskSingle;
                    if (this.markedRow == row.node) {
                        this.UiModder.domClass.remove(this.markedRow, "EvBookingEditorForm selectedTableRow");
                        this.markedRow = null;
                        this.hideNode(this.evTaskAssociateEditorContainer);
                        this.selectedAssociateData = null;
                        return;
                    }

                    if (this.markedRow) {
                        this.UiModder.domClass.remove(this.markedRow, "EvBookingEditorForm selectedTableRow");
                        this.markedRow = null;
                    }

                    this.markedRow = row.node;
                    this.UiModder.domClass.add(this.markedRow, "EvBookingEditorForm selectedTableRow");

                    this.inputSelectedAssociate.setValue(null, true);
                    this.selectedAssociateData = {};

                    this.UiModder.domClass.add(this.saveAssociate, "w3-disabled");

                    entity["ref_vt_address_backoffice"] ? this.originalSelectedAssociateValue = entity["ref_vt_address_backoffice"]["ID"] : this.originalSelectedAssociateValue = "";
                    console.debug("this.originalSelectedAssociateValue", this.originalSelectedAssociateValue);

                    if (entity["ref_task_description"]) {
                        this.inputSelectedAssociate.setRequestParameter("taskDescriptionID", entity.ref_task_description.ID)
                    }
                    this.inputSelectedAssociate.loadListValues(this.originalSelectedAssociateValue, true);

                    this.hideNode(this.evTaskAssociateEditorContainer, false);
                    this.hideNode(this.evTaskMessageContainer);

                    this.selectedAssociateData["ID"] = entity["ID"];
                    this.selectedAssociateData["Classname"] = entity["Classname"];

                } else {

                    this.UiModder.domClass.remove(this.evTaskMessageContainer, "w3-hide");
                    this.UiModder.domClass.add(this.evTaskAssociateEditorContainer, "w3-hide");
                }
            }

            return;
        } else {

            if (this.markedRow) {
                this.UiModder.domClass.remove(this.markedRow, "EvBookingEditorForm selectedTableRow");
                this.markedRow = null;
            }

            this.editedServiceBooking = null;
            this.hideNode(this.servicesEditorContainer);
            this.hideNode(this.servicesEditorMessageContainer);
            this.hideNode(this.evTaskAssociateEditorContainer);
            this.hideNode(this.evTaskMessageContainer);

            this.originalSelectedAssociateValue = "";
        }

        // listName für Aktion
        let listName: string;
        if (entityClass == "ev_cast" || entityClass == "performers") listName = EvBookingEditor_ListNames.EvCast;
        if (entityClass == "ev_program" || entityClass == "opus") listName = EvBookingEditor_ListNames.EvProgram;
        if (entityClass == "service_ev_serv" || entityClass == "pos_ev_serv") listName = EvBookingEditor_ListNames.EvService;
        if (entityClass == "ht_evbooking_evcategorie1" || entityClass == "ev_catagories_1") listName = EvBookingEditor_ListNames.evCategories;
        if (entityClass == "ev_task_single" || entityClass == "ev_task_descript" || entity["ref_task_description"]) listName = EvBookingEditor_ListNames.evTasks;
        if (entityClass == "file_ev_project") listName = EvBookingEditor_ListNames.existingFiles;

        // Aktion
        if (actionType == "moveup") {
            // rauf
            this.moveUp(this.currentData[listName], entity);
            this.drawTable(this.tablesConfig[listName]);
            this.checkIsFormDirty();
        }

        if (actionType == "movedown") {
            // runter
            this.moveDown(this.currentData[listName], entity);
            this.drawTable(this.tablesConfig[listName]);
            this.checkIsFormDirty();
        }
        if (actionType == "delete") {

            // Sonderregel: wenn Leistungsbuchung mit Dienst, dann aus der tabelle löschen...
            let taskIdsToDelete = [];
            if (entityClass == VAMclassNames.service_ev_serv) {
                let svc: VAMtypes.EvService = entity;

                // bei neuen Entities gibt es ggf. eine temporäre GUID die auf targetTaskGUID gespeichert ist:
                if (entityState == "new") {
                    let guid = svc["targetTaskGUID"];
                    taskIdsToDelete.push(guid);
                } else {
                    // kann nicht sein - wenn nicht new, dann ist der Classname pos_ev_serv
                }

            } else if (entityClass == VAMclassNames.pos_ev_serv) {

                if (entityState == "new") {
                    // kann nicht sein, dann wär der classname service_ev_serv
                } else {
                    let svb: VAMtypes.EvServiceBooking = entity;
                    if (svb.evTasks && svb.evTasks.length) {
                        for (let task of svb.evTasks) {
                            taskIdsToDelete.push(task.ID);
                        }
                    }
                }
            }

            if (taskIdsToDelete.length) {
                for (let guid of taskIdsToDelete) {
                    let table: MdsLax<InstanceType<typeof StaticTable<VAMtypes.EvTaskSingle>>> = this.tablesConfig.evTasks.staticTable;
                    let row = table.getRowGroupByKeyValue(guid, entityState == "new" ? "GUID" : "ID");

                    if (row) {
                        let taskArray: Array<object> = this.currentData[EvBookingEditor_ListNames.evTasks];
                        taskArray.splice(row.rowIndex, 1);
                        this.drawTable(this.tablesConfig[EvBookingEditor_ListNames.evTasks]);
                    }
                }
            }

            // löschen
            if (entity["state"] == "new") {

                let currentArray: Array<object> = this.currentData[listName]; // wenn das ding nie aus der api kam, ist es neu und kann daher komplett gelöscht werden
                currentArray.splice(rowIndex, 1);
            } else {

                for (let i = 0; i < this.currentData[listName].length; i++) {

                    if (this.currentData[listName][i]["ID"] == entity["ID"]) {
                        this.currentData[listName][i]["state"] = "deleted";
                        //console.log("zum löschen markiert", this.existingEntity[listName][i], this.existingEntity[listName]);
                    }
                }
            }
            // neu zeichnen...
            this.drawTable(this.tablesConfig[listName]);

            this.checkIsFormDirty();
        }
        if (actionType == "download") {

            //alert("DOWNLOAD!");

            window.open(window.appRoot + `EvBookingEditor/DownloadExistingFile?downloadKey=${entity["ID"]}`)

            //console.debug("ENTITY", entity);
        }

    }

    private moveDown(list: Array<object>, entity: any, orderAttributeName: string = "order") {
        this._initOrderInList(list, orderAttributeName);

        list.filter(function (data) {
            if (data[orderAttributeName] === entity[orderAttributeName] + 1) {
                data[orderAttributeName] = data[orderAttributeName] - 1;
            }
        });
        entity[orderAttributeName]++;

        this._resortEntityList(list);
    }

    private moveUp(list: Array<object>, entity: any, orderAttributeName: string = "order") {
        this._initOrderInList(list, orderAttributeName);

        list.filter(function (data) {
            if (data[orderAttributeName] === entity[orderAttributeName] - 1) {
                data[orderAttributeName] = data[orderAttributeName] + 1;
            }
        });
        entity[orderAttributeName]--;

        this._resortEntityList(list);
    }

    private _resortEntityList(list: Array<object>, orderAttributeName: string = "order") {

        list = list.sort(function (a, b) {
            return a[orderAttributeName] - b[orderAttributeName];
        });
    }

    private _initOrderInList(list: Array<object>, orderAttributeName: string = "order") {
        for (let i = 1; i <= list.length; i++) {
            list[i - 1][orderAttributeName] = i;
        }
    }

    private _onOpenSEDserviceEditor(): void {
        let data = this.currentData as VAM2types.EvBooking_Extended;
        let value = data?.ref_ev_room;
        this.serviceEditor.setRoomId(value?.ID);
    }

    private _onNewBookingListElementFromEditor(value: any, attrArray: Array<string>): void {
        let listName: string = attrArray[0]; // aus emit() zusätzliche Attributen sind in Array
        this.addEntryToList(value, listName);
    }

    private addEntryToList(entity: any, targetListName: string): Object {

        if (this.currentData == null) {
            this.currentData = {
                ID: ""
            };
        }

        if (this.currentData[targetListName] == null || typeof this.currentData[targetListName] == "undefined") {
            this.currentData[targetListName] = [];
        }

        console.log(`_onNew event - ${targetListName}`, entity, "this.existingEntity[listName]", this.currentData[targetListName]);
        let isWithOrder: boolean = false;
        let addEntry: boolean = true;
        let entryString: string = "";
        entity["state"] = "new";

        switch (targetListName) {
            case EvBookingEditor_ListNames.EvCast:
                isWithOrder = true;

                if (!entity["is_red_entry"]) {
                    if (typeof entity == "object") {
                        entity["c_cast_address"] = entity.ref_address.pseudonym;
                        entity["c_cast_perfomer"] = entity.ref_ev_profession.description;
                    } else {
                        entity["c_cast_address"] = entity;
                        entity["c_cast_perfomer"] = "";
                    }

                    addEntry = this.currentData[targetListName]
                        .filter(x => x.ref_performer?.ID === entity.ID || x.ID === entity.ID).length === 0;
                } else {
                    addEntry = this.currentData[targetListName]
                        .filter(x => x.c_cast_address === entity.c_cast_address
                            && x.c_cast_perfomer === entity.c_cast_perfomer).length === 0;
                }
                entryString = `${entity["c_cast_address"]} - ${entity["c_cast_perfomer"]}`;

                break;

            case EvBookingEditor_ListNames.EvProgram:
                isWithOrder = true;

                if (!entity["is_red_entry"]) {
                    entity["c_composer_author"] = entity["gDisp_composer_author"];
                    entity["c_opus"] = entity["opus_titel"];

                    addEntry = this.currentData[targetListName]
                        .filter(x => x.ref_opus?.ID === entity.ID || x.ID === entity.ID).length === 0;
                } else {
                    addEntry = this.currentData[targetListName]
                        .filter(x => x.c_composer_author === entity.c_composer_author
                            && x.c_opus === entity.c_opus
                            && x.duration_min === entity.duration_min).length === 0;
                }
                entryString = `${entity["c_composer_author"]} - ${entity["c_opus"]}`;
                break;

            case EvBookingEditor_ListNames.EvService:

                // achtung, wir bekommen hier  eine Leistung (svc) vom HINZUFÜGEN
                // die Tabelle will aber LeistungsBUCHUNGEN (svb) anzeigen

                let svc: VAMtypes.EvService = entity;
                let svb: VAMtypes.EvServiceBooking = svc as VAMtypes.EvServiceBooking;

                svb.service_type_text = this.translations[`service_type.${svc.service_type}`];
                if (entity.service_type === 1) {

                    svb.quantity_text = ` / ${svc.quantity} ${svc.unitCode}`;
                } else {

                    svb.quantity_text = " - ";
                }

                if (svc.ref_ev_task_descript) {
                    let createdTask = this.addEntryToList(svc.ref_ev_task_descript, EvBookingEditor_ListNames.evTasks)
                    createdTask["state"] = "skip"; // der API sagen dass sie das nicht wirklich erzeugen soll - onchanged in pit macht das
                    createdTask["GUID"] = (Math.random() * 1000 * Math.random() * 1000).toFixed(0);

                    svb["targetTaskGUID"] = createdTask["GUID"];

                }

                entity = svb;

                break;

            case EvBookingEditor_ListNames.evTasks:
                isWithOrder = true;

                entity["ref_task_description"] = {};
                entity["ref_task_description"]["description"] = entity["description"];
                entity["ref_task_description"]["ID"] = entity["ID"];
                entity["ref_vt_address_backoffice"] = {};
                entity["ref_vt_address_backoffice"]["gDisp_1"] = "N.A.";
                break;
            case EvBookingEditor_ListNames.evCategories:
                //
                addEntry = this.currentData[targetListName]
                    .filter(x => x.categoryID === entity.ID || x.ID === entity.ID).length === 0;
                entryString = `${entity["description"]}}`;
                break;
        }

        if (isWithOrder) entity["order"] = this.currentData[targetListName].length + 1;

        if (addEntry) {
            this.currentData[targetListName].push(entity);
            this.drawTable(this.tablesConfig[targetListName]);
        } else {

            let msg = this.stringFormat(this.translations["EvBookingEditor_Table_ToastMessage"], entryString);

            this.showToast({
                title: this.translations["EvBookingEditor_Table_ToastTitle"],
                iconClass: "fas fa-warning",
                message: msg,
                options: {
                    closeButton: true,
                    timeout: 10000
                }
            });
        }
        //this.currentData[targetListName] = this.sourceData[targetListName];
        //this._initOrderInList(this.allValues[listName], "order");
        this.checkIsFormDirty();
        return entity;
    }




    private _onClosedDialog(): void {

    }

    private _onClick_OpenEvCategoriesSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvCategory",
            lang.hitch(this, this._onCallback_Dlg)
        );
    }
    private _onClick_OpenEvCastSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvCast",
            lang.hitch(this, this._onCallback_Dlg)
        );
    }
    private _onClick_OpenEvProgramSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvProgram",
            lang.hitch(this, this._onCallback_Dlg)
        );

    }


    private _onCallback_Dlg(mode: string, data, items) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet
        if (!items || !items.length) return;

        for (let item of items) {
            let entity = {
                ID: item.entry.value, gDisp_1: item.entry.label
            }

            if (mode == "selectEvCategory") {

                this.evCategoriesEditor.categoryInput.setValue(item.entry.data)
            }
            if (mode == "selectEvCast") {

                this.castEditor.performerInput.setValue(item.entry.data);
            }
            if (mode == "selectEvProgram") {

                this.programEditor.opusInput.setValue(item.entry.data);
            }
            //this.previousSEDvalue = items;
        }


    }


    private setupHintboxes() {
        this.evCategoriesEditor.categoryInput.addInlineButton(lang.hitch(this, this._onClick_OpenEvCategoriesSED));
        this.castEditor.performerInput.addInlineButton(lang.hitch(this, this._onClick_OpenEvCastSED));
        this.programEditor.opusInput.addInlineButton(lang.hitch(this, this._onClick_OpenEvProgramSED));
    }

    private openServiceEditor(entity: VAMtypes.EvServiceBooking) {
        this.editedServiceBooking = { ...entity };

        this.UiModder.domAttr.set(this.txtServiceEditorHeading, "innerHTML", entity.description);

        this.hideNode(this.servicesEditorContainer, false);
        this.hideNode(this.servicesEditorMessageContainer);

        switch (entity["service_type"]) {
            case 1: //standard
                this.hideNode(this.servicesEditor_PriceEditorContainer, false);
                if (this.hasFeature("EvBooking/ServiceEditWithInternalNote")) {

                    this.hideNode(this.servicesEditor_NoteInternalTextEditorContainer, false);
                    this.edit_serviceNoteInternalTxt.setValue(entity.ev_service_text_internal, true);
                    this.edit_serviceNoteInternalTxt.isMandatory = false;
                }
                this.hideNode(this.servicesEditor_TextEditorContainer, true);

                this.oversteeredPriceCheckbox.setValue(entity["is_oversteered_price"], true);
                this.freePriceCheckbox.setValue(!entity["ref_pricelist"], true);
                this.priceTotalPricelistCheckbox.setValue(entity["is_price_total_pricelist"], true);
                this._onPriceCheckboxInputs();

                this.numberInput_PriceUnitChange.setValue(entity.price_unit_change, true);
                this.numberInput_PriceUnitPricelist.setValue(entity.price_unit_pricelist, true);
                this.numberInput_PriceTotalPricelist.setValue(entity.price_total_pricelist, true);
                this.numberInput_ValueAgiodisagioUnit.setValue(entity.value_agiodisagio_unit, true);
                this.numberInput_ValueAgiodisagioTotal.setValue(entity.value_agiodisagio_total, true);
                this.numberInput_Discount.setValue(entity.discount, true);
                this.numberInput_ValueDiscountUnit.setValue(entity.value_discount_unit), true;
                this.numberInput_ValueDiscountTotal.setValue(entity.value_discount_total, true);
                this.numberInput_PriceUnitAfterDisc.setValue(entity.price_unit_after_disc, true);
                this.numberInput_PriceTotalAfterDisc.setValue(entity.price_total_after_disc, true);
                this.numberInput_VatValue.setValue(entity.VAT_value, true);
                this.numberInput_PriceTotalInclVat.setValue(entity.price_total_incl_VAT, true);
                break;
            case 4: //text
                this.UiModder.domAttr.set(this.txtServiceEditorHeading, "innerHTML", entity["service_original_description"]);

                this.hideNode(this.servicesEditor_PriceEditorContainer, true);
                this.hideNode(this.servicesEditor_TextEditorContainer, false);

                this.edit_serviceTxt.setValue(entity.description, true);
                break;
            default:
        }
    }

    private _onClick_CloseServiceEditorContainer(evt: MouseEvent) {

        this.hideNode(this.servicesEditorContainer);
        if (this.markedRow) {
            this.UiModder.domClass.remove(this.markedRow, "EvBookingEditorForm selectedTableRow");
        }

        this.markedRow = null;
        this.editedServiceBooking = null;
    }

    private _onChangeOversteeredPriceInput(value: any): void {

        if (this.editedServiceBooking !== null) this.editedServiceBooking["is_oversteered_price"] = this.oversteeredPriceCheckbox.getValue();
        //console.debug("OversteeredPrice", value, this.editedServiceBooking, this.existingEntity);
    }

    private _onChangeSelectedAssociateInputData(): void {

        let value = this.inputSelectedAssociate.getValue();

        if (value == this.originalSelectedAssociateValue) {

            this.UiModder.domClass.add(this.saveAssociate, "w3-disabled");
        } else {

            this.UiModder.domClass.remove(this.saveAssociate, "w3-disabled");
        }

        this.selectedAssociateData["selectedAssociateID"] = value;
    }

    private _onClickSaveAssociateButton(e): void {

        console.debug(this.selectedAssociateData);

        let requestUrl = window.appRoot + "EvBookingEditor/AssignAssociateData";
        this.StandbyStart(this.evTaskAssociateEditorContainer);

        if (this.selectedAssociateData["selectedAssociateID"]) {

            this.RequestManager.post(
                requestUrl,
                {
                    jsonData: JSON.stringify(this.selectedAssociateData)
                },
                lang.hitch(this, this._onAssignAssociateDataResponse),
                lang.hitch(this, this._onAssignAssociateDataError),
                false // sync
            );
        }
    }

    private _onAssignAssociateDataResponse(response): void {
        this.StandbyStop();

        this.hideNode(this.evTaskAssociateEditorContainer);

        this.emit("bookingEditorAssignAssociateResponse");
    }

    private _onAssignAssociateDataError(err): void {
        this.StandbyStop();

        alert(err.Message);
    }

    private _onClickSaveChangesButton(): void {
        this.StandbyStart(this.servicesEditorContainer);

        setTimeout(lang.hitch(this, this.saveEvServiceChangesData), 333);
    }

    private saveEvServiceChangesData(): void {
        let requestUrl = window.appRoot + "EvBookingEditor/SaveServiceChangesData";

        if (this.editedServiceBooking != null) {

            this.RequestManager.post(
                requestUrl,
                {
                    jsonData: JSON.stringify(this.editedServiceBooking)
                },
                lang.hitch(this, this._onSaveEvServiceChangesDataResponse),
                lang.hitch(this, this._onSaveEvServiceChangesDataError),
                false // sync
            );
        }
    }

    private _onSaveEvServiceChangesDataResponse(response): void {
        this.StandbyStop();
        this.emit("bookingEditorPricelistCalculationResponse");

        this._onClick_CloseServiceEditorContainer(null);
    }

    private _onSaveEvServiceChangesDataError(err): void {
        this.StandbyStop();

        alert(err.Message);
    }

    private _onChangepriceDataNumberInputs(): void {

        if (!this.editedServiceBooking) {
            return;
        }

        let price_unit_change = this.numberInput_PriceUnitChange.getValue();
        price_unit_change === null ? this.editedServiceBooking.price_unit_change = 0 : this.editedServiceBooking.price_unit_change = price_unit_change;

        let price_unit_pricelist = this.numberInput_PriceUnitPricelist.getValue();
        price_unit_pricelist === null ? this.editedServiceBooking.price_unit_pricelist = 0 : this.editedServiceBooking.price_unit_pricelist = price_unit_pricelist;

        let price_total_pricelist = this.numberInput_PriceTotalPricelist.getValue();
        price_total_pricelist === null ? this.editedServiceBooking.price_total_pricelist = 0 : this.editedServiceBooking.price_total_pricelist = price_total_pricelist;

        let discount = this.numberInput_Discount.getValue();
        discount === null ? this.editedServiceBooking.discount = 0 : this.editedServiceBooking.discount = discount;


    }

    private _onChange_serviceTxt(): void {

        this.editedServiceBooking["service_txt"] = this.edit_serviceTxt.getValue();
    }

    private _onChange_serviceNoteInternalTxt(): void {

        this.editedServiceBooking["ev_service_text_internal"] = this.edit_serviceNoteInternalTxt.getValue();
    }

    private _onPriceCheckboxInputs(): void {

        let bOversteeredPrice = this.oversteeredPriceCheckbox.getValue();
        if (bOversteeredPrice === false) {

            this.freePriceCheckbox.setValue(false, true);
            this.priceTotalPricelistCheckbox.setValue(false, true);
        }

        let bFreePrice = this.freePriceCheckbox.getValue();
        if (bFreePrice === false) {

            this.priceTotalPricelistCheckbox.setValue(false, true);
        }

        let bPriceTotalPricelist = this.priceTotalPricelistCheckbox.getValue();

        if (this.editedServiceBooking !== null) {

            this.editedServiceBooking["is_oversteered_price"] = this.oversteeredPriceCheckbox.getValue();
            this.editedServiceBooking["is_free_price"] = this.freePriceCheckbox.getValue();
            this.editedServiceBooking["is_price_total_pricelist"] = this.priceTotalPricelistCheckbox.getValue();
        }

        this.adjustPricelistEdit(bOversteeredPrice, bFreePrice, bPriceTotalPricelist);
    }

    private adjustPricelistEdit(bOversteeredPrice: boolean, bFreePrice: boolean, bPriceTotalPricelist: boolean): void {

        this.numberInput_PriceUnitChange.setReadonly(true);
        this.numberInput_PriceUnitPricelist.setReadonly(true);
        this.numberInput_PriceTotalPricelist.setReadonly(true);
        this.numberInput_Discount.setReadonly(true);

        if (bOversteeredPrice) {

            this.numberInput_PriceUnitChange.setReadonly(false);
            this.numberInput_Discount.setReadonly(false);
        }
        if (bFreePrice) {

            this.numberInput_PriceUnitChange.setReadonly(true);
            this.numberInput_PriceUnitPricelist.setReadonly(false);
        }
        if (bPriceTotalPricelist) {

            this.numberInput_PriceTotalPricelist.setReadonly(false);
            this.numberInput_PriceUnitPricelist.setReadonly(true);
        }
    }

    // --------------------------inputEvents -----------------------END
    // input requests ------------------------------------------------START

    // input requests ------------------------------------------------END
    // formdata ---------------------------------------------------------START
    adjustSectionsVisibility(): void {

        for (let p in this.tablesConfig) {

            let config: EvBookingEditor_TableConfig = this.tablesConfig[p];

            if (!config.isVisible) {

                this.UiModder.domClass.add(config.sectionContainer, "w3-hide");
                this.UiModder.domConstruct.destroy(config.sectionContainer);
            }

            switch (config.name) {
                case EvBookingEditor_ListNames.evTasks:
                    if (config.isVisible) {
                        this.evTaskEditor = new EvTaskEditor();
                        this.evTaskEditor.placeAt(this.evTaskEditor_container);
                        //this.evTaskEditor.addExistingEmployees(); // ich muss ja irgendwie einschleusen, dass ich bestehende Mitarbeiter nicht nochmal auswählen kann
                        // keine Ahnung wo ich die Info in dem Editor bekomme
                        on(this.evTaskEditor, "added", lang.hitch(this, this._onNewBookingListElementFromEditor));
                    }
                    break;
            }
        }

        //if (this.evBookingEditorSectionsConfig && this.evBookingEditorSectionsConfig.isBookerSectionVisible) this.bookerInput._loadListValues(this.bookerInputPresetValue, this.bookerInputPresetValue === null);
    }

    private drawTable(config?: EvBookingEditor_TableConfig): void {

        if (!config) {
            for (let p in this.tablesConfig) {
                this.drawTable(this.tablesConfig[p]);
            }
            return;
        }

        if(!config.isVisible) return;

        config.tableContainer.innerHTML = null;
        if (config.staticTable != null) {
            config.staticTable.destroy();
        }

        config.staticTable = new StaticTable();
        config.staticTable.setFormatter(lang.hitch(this, this.table_formatterFunction));
        config.staticTable.setHeadingLabelFormatter(this.table_formatterFunction__headingLabel);

        config.staticTable.addLineConfig(config.tableLayout);

        config.staticTable.setCyAttribute("evBookingLegacySections");

        this.UiModder.domConstruct.place(config.staticTable.domNode, config.tableContainer);

        let list = [];
        for (let i = 0; i < this.currentData[config.name]?.length; i++) {

            switch (config.name) {
                case EvBookingEditor_ListNames.EvService:
                    let service: VAMtypes.EvServiceBooking = this.currentData[config.name][i];
                    let origService: VAMtypes.EvServiceBooking = null // dummy
                    if (this.currentData != null) {
                        origService = this.currentData[config.name][i];
                    }

                    if (!service.quantity_text) {

                        if (service.service_type === 1) {
                            service.quantity_text = ` / ${service["quantity"]} ${service.unitCode}`;
                        } else {
                            service.quantity_text = " - ";
                        }
                        if (typeof (origService) != "undefined" && origService.ID === service["ID"]) origService.quantity_text = service["quantity_text"];
                    }

                    if (!service.service_type_text) {
                        service.service_type_text = this.translations[`service_type_${service["service_type"]}`];
                        if (typeof (origService) != "undefined" && origService != null && origService["ID"] === service["ID"]) origService.service_type_text = service.service_type_text;
                    }

                    if (service["state"] != "deleted") {
                        list.push(service);
                    }
                    break;

                default:
                    if (this.currentData[config.name][i]["state"] != "deleted") {
                        list.push(this.currentData[config.name][i]);
                    }
            }
        }

        config.staticTable.setData(list);

        if (config.sectionContainer.expander) {
            config.sectionContainer.expander.setMarking(list.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        }
    }

    protected afterSetData(): void {
        let entity: VAMtypes.EvBookingEditorEntity = this.currentData;

        this.resetFileUploadInput(); // Nach dem Speichern wird es nicht neu geladen und alte Dateien-Rows bleiben

        //this.currentData["newUploadFiles"] = [];

        if (entity && entity.ID) {

            this.currentData["ID"] = entity.ID;
            this.currentData["Classname"] = entity.Classname;

            for (let p in this.tablesConfig) {

                let listName: string = this.tablesConfig[p].name;

                this.currentData[listName] = entity[listName];
            }

            this.displayExistingEntityValues();
        }
    }

    private displayExistingEntityValues(): void {

        this.drawTable();

        this.resetDirty();
    }


    private getAttachPointNameForWidget(widget: MdsLax<InstanceType<typeof _StatefulBase>>): string {
        for (let attachPointName of this._attachPoints) {
            if (this[attachPointName] == widget) {
                return attachPointName;
            }
        }
    }

    checkIsFormDirty(): boolean {

        console.debug(this.id + " dirty check ORIGINAL DATA", this.sourceData);
        console.debug(this.id + " dirty check CURRENT DATA", this.currentData);


        //let actualPropertyNames = Object.getOwnPropertyNames(this.currentData);

        //for (let propertyName of actualPropertyNames) {


        //    switch (propertyName) {
        //        case "cast":
        //        case "program":
        //        case "service":
        //        case "evTasks":
        //        case "evCategories":
        //        case "orchestraEmployments":
        //        case "existingFiles":
        //        case "newUploadFiles":
        //            if (!this.sourceData.hasOwnProperty(propertyName)) return true;

        //            let currentValue = this.currentData[propertyName];
        //            let originalValue = this.sourceData[propertyName];
        //            if (JSON.stringify(currentValue) != JSON.stringify(originalValue)) {
        //                //console.debug("dirty value: ", propertyName, { currentValue: currentValue, originalValue: originalValue }, this.sourceData, this.currentData);
        //                return true;
        //            }
        //            break;
        //    }
        //}

        return this.isDirty(true);

    }


    // formdata ---------------------------------------------------------END

    //  -------getters && setters --------------------------START

    private addTooltipsForServiceCheckboxes(): void {

        let tooltip = new Tooltip();
        tooltip.setup({
            content: this.translations["EvBookingditor_CheckboxTooltip_OversteeredPrice"],
            targetnode: this.oversteeredPriceCheckbox.domNode
        });

        tooltip = new Tooltip();
        tooltip.setup({
            content: this.translations["EvBookingditor_CheckboxTooltip_FreePrice"],
            targetnode: this.freePriceCheckbox.domNode
        });

        tooltip = new Tooltip();
        tooltip.setup({
            content: this.translations["EvBookingditor_CheckboxTooltip_PriceTotalPricelist"],
            targetnode: this.priceTotalPricelistCheckbox.domNode
        });

        //    this.UiModder.domClass.add(this.oversteeredPriceCheckbox.labelNodeRight, "w3-tooltip");
        //    this.UiModder.domConstruct.create("span", {
        //        style: "position:absolute;left:22px;bottom:16px; pointer-events:none; z-index: 2; min-width: 300px;",
        //        class: "w3-text w3-tag w3-pale-yellow w3-round w3-animate-opacity w3-border",
        //        innerHTML: this.translations["EvBookingditor_CheckboxTooltip_OversteeredPrice"]
        //    }, this.oversteeredPriceCheckbox.labelNodeRight);

        //    this.UiModder.domClass.add(this.freePriceCheckbox.labelNodeRight, "w3-tooltip");
        //    this.UiModder.domConstruct.create("span", {
        //        style: "position:absolute;left:22px;bottom:16px; pointer-events:none; z-index: 2; min-width: 300px;",
        //        class: "w3-text w3-tag w3-pale-yellow w3-round w3-animate-opacity w3-border",
        //        innerHTML: this.translations["EvBookingditor_CheckboxTooltip_FreePrice"]
        //    }, this.freePriceCheckbox.labelNodeRight);

        //    this.UiModder.domClass.add(this.priceTotalPricelistCheckbox.labelNodeRight, "w3-tooltip");
        //    this.UiModder.domConstruct.create("span", {
        //        style: "position:absolute;left:22px;bottom:16px; pointer-events:none; z-index: 2; min-width: 300px;",
        //        class: "w3-text w3-tag w3-pale-yellow w3-round w3-animate-opacity w3-border",
        //        innerHTML: this.translations["EvBookingditor_CheckboxTooltip_PriceTotalPricelist"]
        //    }, this.priceTotalPricelistCheckbox.labelNodeRight);
    }

    setBookingListTablesConfig(): void {

        let cast: EvBookingEditor_TableConfig = {
            name: EvBookingEditor_ListNames.EvCast,
            staticTable: null,
            tableContainer: this.bookingCastTableContainer,
            sectionContainer: this.castContainer,
            tableLayout: this.castTableLayout,
            isVisible: true
        }
        let program: EvBookingEditor_TableConfig = {
            name: EvBookingEditor_ListNames.EvProgram,
            staticTable: null,
            tableContainer: this.bookingProgramTableContainer,
            sectionContainer: this.programContainer,
            tableLayout: this.hasUserRole(["OM", "EvBooking_OM"]) ? this.programTableLayout_om : this.programTableLayout,
            isVisible: true
        }
        let service: EvBookingEditor_TableConfig = {
            name: EvBookingEditor_ListNames.EvService,
            staticTable: null,
            tableContainer: this.serviceTableContainer,
            sectionContainer: this.serviceContainer,
            tableLayout: this.serviceTableLayout,
            isVisible: true
        }
        let evTasks: EvBookingEditor_TableConfig = {
            name: EvBookingEditor_ListNames.evTasks,
            staticTable: null,
            tableContainer: this.bookingEvTaskTableContainer,
            sectionContainer: this.evTaskContainer,
            tableLayout: this.evTaskTableLayout,
            isVisible: true
        }
        let evCategories: EvBookingEditor_TableConfig = {
            name: EvBookingEditor_ListNames.evCategories,
            staticTable: null,
            tableContainer: this.bookingEvCategoryTableContainer,
            sectionContainer: this.evCategoryContainer,
            tableLayout: this.evCategoriesTableLayout,
            isVisible: true
        }
        let orchestraEmployments: EvBookingEditor_TableConfig = {
            name: EvBookingEditor_ListNames.orchesterEmployements,
            staticTable: null,
            tableContainer: this.orchesterEmploymentTableContainer,
            sectionContainer: this.orchesterEmploymentContainer,
            tableLayout: this.orchesterEmploymentTableLayout,
            isVisible: true
        }
        let existingFiles: EvBookingEditor_TableConfig = {
            name: EvBookingEditor_ListNames.existingFiles,
            staticTable: null,
            tableContainer: this.bookingFilesTableContainer,
            sectionContainer: this.filesSectionContainer,
            tableLayout: this.existingFilesTableLayout,
            isVisible: true
        }

        this.tablesConfig = {
            cast: cast,
            program: program,
            service: service,
            evTasks: evTasks,
            evCategories: evCategories,
            orchestraEmployments: orchestraEmployments,
            existingFiles: existingFiles,
        }
    }

    private addDefaultCategoryToFile(file: { guid: string, filenames: string[] }): void {

        file["fileCategories"] = [];
        file["filenames"].forEach(fileName => {

            file["fileCategories"].push({
                fileName: fileName,
                category: this.fileCategories[0].ID
            });
        });
    }

    resetFileUploadInput(): void {

        this.fileUpload.resetFileUpload();
        this.newUploadFiles = [];
    }

    private _onChangeUploadFile(guid) {

        let newFilesArr = this.fileUpload.getValue();

        if (newFilesArr && this.fileUpload.validateInput()) {

            if (this.newUploadFiles.length === 0) {
                this.newUploadFiles = newFilesArr;
                this.newUploadFiles.forEach(file => {

                    this.addDefaultCategoryToFile(file);
                });

                this.currentData["newUploadFiles"] = this.newUploadFiles;
                console.debug("newUploadFiles", this.currentData["newUploadFiles"]);
                this.checkIsFormDirty();

                return;
            }

            newFilesArr.forEach(file => {

                let guid = file.guid;
                let fileNames = file.filenames
                let existingFile = this.newUploadFiles.filter(x => x["guid"] === guid)[0];

                if (!existingFile) {

                    this.addDefaultCategoryToFile(file);

                    this.newUploadFiles.push(file);
                } else {

                    if (existingFile && existingFile["fileCategories"] && existingFile["fileCategories"].length > fileNames.length) {

                        let catToDelete = existingFile["filenames"].filter(x => fileNames.indexOf(x) === -1);

                        if (catToDelete) existingFile["fileCategories"].splice(existingFile["fileCategories"].indexOf(existingFile["fileCategories"].filter(x => x["fileName"] === catToDelete)[0]), 1);
                    }

                    if (!existingFile["fileCategories"] || existingFile["fileCategories"].length == 0) {

                        this.addDefaultCategoryToFile(existingFile);
                    }
                }
            });

            this.currentData["newUploadFiles"] = this.newUploadFiles;
        } else {

            this.newUploadFiles = [];
            delete this.currentData["newUploadFiles"];
        }

        this.checkIsFormDirty();

        console.debug("newUploadFiles", this.currentData["newUploadFiles"]);
    }

    private _loadFileCategoriesList(): void {

        let requestUrl = window.appRoot + "EvBookingEditor/GetFileCategoriesList";

        this.RequestManager.post(
            requestUrl,
            {
                jsonData: null
            },
            (response: any) => { this.fileCategories = response },
            (err: any) => { alert(err.Message) },
            false // sync
        );
    }

    protected setupSelectBoxInFileRow(evt: { name: string, row: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>> }): void {

        console.trace();

        let fileRow = evt.row;

        let selectBox = new SearchSelect();
        selectBox.setCyName("fileCategories");

        selectBox.labelAttribute = "description";
        selectBox.setLabel(this.translations["General_Label_Category"]);
        selectBox.setSelectionListLEGACY(this.fileCategories);

        console.log(this.fileCategories);

        let categoryToSet = this.fileCategories[0].ID;

        console.log(categoryToSet);

        let newFilesArray: Array<any> = this.currentData["newUploadFiles"];

        if (newFilesArray?.length) {
            newFilesArray.forEach(file => {

                if (file["guid"] === fileRow.getData()["uploadGUID"]) {

                    if (file["fileCategories"]) categoryToSet = file["fileCategories"].filter(x => x["fileName"] === fileRow.getData()["FileName"])[0]["category"];
                }
            });
        }


        selectBox.setValue(categoryToSet, true);

        selectBox.on("change", lang.hitch(this, this.assignCategoryToNewFile, fileRow, selectBox.getValue()));


        fileRow.addContent_LEGACY(true, selectBox.domNode);
    }

    private assignCategoryToNewFile(fileRow: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>, value: string): void {

        console.log(fileRow, value);

        let rowFileGuid = fileRow.getData()["uploadGUID"];
        let rowFileName = fileRow.getData()["FileName"];
        let fileToSave = this.currentData["newUploadFiles"].filter(x => x["guid"] === rowFileGuid)[0];

        //if (fileToSave) fileToSave["fileCategoryID"] = value;
        if (fileToSave) fileToSave["fileCategories"].filter(x => x["fileName"] === rowFileName)[0]["category"] = value;

        console.debug("newUploadFiles", this.currentData["newUploadFiles"]);
    }
    private setupExpanderSections() {
        let expander = new ExpandableSection();

        if (this.hasUserRole(["EvCast_Read"]) &&
            !this.hasFeature("EvBooking_LegacyEditor/hideCast") &&
            !this.hasFeature("EvBooking/EvCast")) /* gegen Doppelung! */ {
            this.hideNode(this.castContainer, false);
            this.castContainer = expander.setupAsReplacement(
                this.castContainer,
                this.translations["BookingEditor__castTableLabel"],
                "medium",
                true, true, false
            );
        }

        if (this.hasUserRole("EvProgram_Read") &&
            !this.hasFeature("EvBooking_LegacyEditor/hideProgram") &&
            !this.hasFeature("EvBooking/EvProgram")) /* gegen Doppelung! */ {
            this.hideNode(this.programContainer, false);
            expander = new ExpandableSection();
            this.programContainer = expander.setupAsReplacement(
                this.programContainer,
                this.translations["BookingEditor__programTableLabel"],
                "medium",
                true, true, false
            );
        }

        if (this.hasUserRole("Service_Read") &&
            !this.hasFeature("EvBooking_LegacyEditor/hideServices") &&
            !this.hasFeature("EvBooking/EvService")) /* gegen Doppelung! */ {
            this.hideNode(this.serviceContainer, false);
            expander = new ExpandableSection();
            this.serviceContainer = expander.setupAsReplacement(
                this.serviceContainer,
                this.translations["BookingEditor__serviceTableLabel"],
                "medium",
                true, true, false
            );
        }

        if (this.hasUserRole("OmEmployment_ReadXXX") && !this.hasFeature("EvBooking_LegacyEditor/hideOmEmployment")) { // TODO: OM-Section defacto nicht im Einsatz. ggf. Rechtename prüfen...
            this.hideNode(this.orchesterEmploymentContainer, false);
            expander = new ExpandableSection();
            this.orchesterEmploymentContainer = expander.setupAsReplacement(
                this.orchesterEmploymentContainer,
                this.translations["MyEmployments_Title2"],
                "medium",
                true, true, false
            );
        }

        if (this.hasUserRole("EvTask_Read") && !this.hasFeature("EvBooking_LegacyEditor/hideEvTask")) {
            this.hideNode(this.evTaskContainer, false);
            expander = new ExpandableSection();
            this.evTaskContainer = expander.setupAsReplacement(
                this.evTaskContainer,
                this.translations["BookingEditor__EvTaskTableLabel"],
                "medium",
                true, true, false
            );
        }

        if (this.hasUserRole("EvCategory_Read") && !this.hasFeature("EvBooking_LegacyEditor/hideEvCategory")) {
            this.hideNode(this.evCategoryContainer, false);
            expander = new ExpandableSection();
            this.evCategoryContainer = expander.setupAsReplacement(
                this.evCategoryContainer,
                this.translations["BookingEditor__EvCategoryTableLabel"],
                "medium",
                true, true, false
            );
        }

        //Deactivate
        if (this.hasUserRole("Files_Read") && !this.hasFeature("EvBooking_LegacyEditor/hideFiles") && false) {
            this.hideNode(this.filesSectionContainer, false);
            expander = new ExpandableSection();
            this.filesSectionContainer = expander.setupAsReplacement(
                this.filesSectionContainer,
                this.translations["General_Label_Files"],
                "medium",
                true, true, false
            );
        }
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.addTooltipsForServiceCheckboxes();

        this.setupHintboxes();
        this.setupExpanderSections();

        this.setBookingListTablesConfig();

        this.SEDconfigCallfunction = "Webtool_API_EvBooking__SED_GetConfig";

        //topic.subscribe("FileUploadDisplay/NewRowCreated", lang.hitch(this, this.setupSelectBoxInFileRow))

        this.fileUpload.on("NewRowCreated", lang.hitch(this, this.setupSelectBoxInFileRow));

        let module: { customTableLayouts: Array<{ id: string } & StaticTable.RowConfig> } = this.getModule("EvBooking");
        if (module?.customTableLayouts?.length) {

            for (let layout of module.customTableLayouts) {
                try {
                    if (layout.id == "ServiceTable") {
                        this.serviceTableLayout.attributes = layout.attributes;
                        this.serviceTableLayout.colNamesInternal = layout.colNamesInternal;
                        this.serviceTableLayout.colspans = layout.colspans;
                        this.serviceTableLayout.headings = layout.headings;
                        this.serviceTableLayout.widths = layout.widths;
                        this.serviceTableLayout.alignmentsHeading = layout.alignmentsHeading;
                        this.serviceTableLayout.alignmentsRow = layout.alignmentsRow;
                    }
                } catch (ex) {
                    console.warn("invalid table layout in appsettings?", layout, module)
                }
            }
        }

        //    this.roomInput.addConditionalFormat("is_vacant_on_date", false, "EvRoomNotVacant");
        //    this.roomInput.addConditionalFormat("is_vacant_on_date", true, "EvRoomVacant");
        if (this.hasFeature("EvBooking/ServiceTableFormatKBB")) {
            this.serviceTableLayout.attributes = ["description", "service_type_text", "quantity_text", "price_total_after_disc", "ev_service_text_internal", ""];
            this.serviceTableLayout.colNamesInternal = ["description", "service_type_text", "quantity_text", "price_total_after_disc", "ev_service_text_internal", "Aktionen_WithEdit"];
            this.serviceTableLayout.colspans = [1, 1, 1, 1, 1];
            this.serviceTableLayout.headings = [this.translations["General_Description"], this.translations["General_Label_Type"], this.translations["General_Label_Quantity"], this.translations["General_Label_Price_Net"], this.translations["General_Label_Note"], "Aktionen_WithEdit"];
            this.serviceTableLayout.widths = [null, "16ch", "18ch", "10ch", "20ch", "16ch"];
            this.serviceTableLayout.alignmentsHeading = [null, null, null, null, null, "right"];
            this.serviceTableLayout.alignmentsRow = [null, null, null, null, null, "right"];
        }
        if (this.hasFeature("EvBooking/ServiceTableFormatAmbach")) {
            let pos = this.serviceTableLayout.attributes.length - 1;

            this.serviceTableLayout.attributes.splice(pos, 0, "discount");
            this.serviceTableLayout.colNamesInternal.splice(pos, 0, "discount");
            this.serviceTableLayout.colspans.push(1);
            this.serviceTableLayout.headings.splice(pos, 0, this.translations["General_Label_Discount"]);
            this.serviceTableLayout.widths.splice(pos, 0, "8ch");
            this.serviceTableLayout.alignmentsHeading.splice(pos, 0, null);
            this.serviceTableLayout.alignmentsRow.splice(pos, 0, "center");
        }
    }
    startup(): void {

        if (!this.hasFeature("EvBooking/LegacyEditor")) return;

        this._loadFileCategoriesList();
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvBookingLegacySections);
